import CobraSpinner from '../shared/CobraSpinner';
import React, { useState } from 'react';
import { Box, Container, VStack, Heading, keyframes} from '@chakra-ui/react';
import ReactPlayer from 'react-player';

// Animation keyframes
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const PublicVideoPage = () => {
    // Replace with the actual URL of the video
    const videoUrl = ""; 
    const [isReady, setIsReady] = useState(false);

    return (
        <Box
            minHeight="100vh"
            bgGradient="linear(135deg, #667eea 0%, #764ba2 100%)"
            position="relative"
            overflow="hidden"
            onContextMenu={(e) => e.preventDefault()}
        >
            {/* Animated background pattern */}
            <Box
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                opacity="0.1"
                backgroundImage="radial-gradient(circle at 20% 50%, rgba(255,255,255,0.2) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.2) 0%, transparent 50%)"
            />

            <Container maxW="container.xl" py={{ base: 8, md: 16 }} position="relative" zIndex={1}>
                <VStack spacing={{ base: 6, md: 10 }} align="stretch">
                    {/* Logo and Header with gradient text */}
                    <VStack spacing={4}>
                        <Box
                            animation={`${fadeIn} 0.6s ease-out`}
                            p={4}
                            bg="rgba(255, 255, 255, 0.1)"
                            backdropFilter="blur(10px)"
                            borderRadius="2xl"
                            border="1px solid rgba(255, 255, 255, 0.2)"
                            boxShadow="0 4px 16px 0 rgba(31, 38, 135, 0.2)"
                        >
                            <img
                                src="/assets/logo.png"
                                alt="Cobra Logo"
                                style={{
                                    height: '80px',
                                    width: 'auto',
                                    objectFit: 'contain'
                                }}
                            />
                        </Box>
                        <Heading
                            as="h1"
                            size={{ base: "xl", md: "2xl" }}
                            textAlign="center"
                            bgGradient="linear(to-r, white, rgba(255,255,255,0.8))"
                            bgClip="text"
                            fontWeight="extrabold"
                            letterSpacing="tight"
                            animation={`${fadeIn} 0.8s ease-out`}
                        >
                            LES TAUX DE MARGE
                        </Heading>
                        <Box
                            height="4px"
                            width="100px"
                            bgGradient="linear(to-r, #ffd89b, #19547b)"
                            borderRadius="full"
                            animation={`${fadeIn} 1s ease-out`}
                        />
                    </VStack>

                    {/* Video Player Card with glassmorphism */}
                    <Box
                        animation={`${fadeIn} 1.2s ease-out`}
                        bg="rgba(255, 255, 255, 0.1)"
                        backdropFilter="blur(20px)"
                        border="1px solid rgba(255, 255, 255, 0.2)"
                        borderRadius="3xl"
                        overflow="hidden"
                        boxShadow="0 8px 32px 0 rgba(31, 38, 135, 0.37)"
                        transition="all 0.3s ease"
                        _hover={{
                            transform: "translateY(-4px)",
                            boxShadow: "0 12px 40px 0 rgba(31, 38, 135, 0.5)"
                        }}
                    >
                        <Box
                            position="relative"
                            paddingBottom="56.25%" // 16:9 aspect ratio
                            bg="black"
                        >
                            {videoUrl ? (
                                <>
                                    {!isReady && (
                                        <Box display="flex" justifyContent="center" alignItems="center" height="100%" position="absolute" width="100%" bg="gray.900" zIndex={1}>
                                            <CobraSpinner size="xl" color="blue.400" thickness="4px" />
                                        </Box>
                                    )}
                                    <ReactPlayer
                                        url={videoUrl}
                                        controls
                                        width="100%"
                                        height="100%"
                                        onReady={() => setIsReady(true)}
                                        style={{ position: 'absolute', top: 0, left: 0 }}
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: 'nodownload'
                                                }
                                            }
                                        }}
                                    />
                                </>
                            ) : (
                                <Box display="flex" justifyContent="center" alignItems="center" height="100%" position="absolute" width="100%" color="white" bg="gray.800" fontWeight="bold" fontSize="lg">
                                    لا يوجد رابط للفيديو
                                </Box>
                            )}
                        </Box>
                    </Box>


                </VStack>
            </Container>

            {/* Floating particles effect */}
            <Box
                position="absolute"
                top="10%"
                left="5%"
                width="6px"
                height="6px"
                borderRadius="full"
                bg="white"
                opacity="0.4"
                animation={`${pulse} 3s ease-in-out infinite`}
            />
            <Box
                position="absolute"
                top="60%"
                right="10%"
                width="8px"
                height="8px"
                borderRadius="full"
                bg="white"
                opacity="0.3"
                animation={`${pulse} 4s ease-in-out infinite 1s`}
            />
            <Box
                position="absolute"
                bottom="20%"
                left="15%"
                width="4px"
                height="4px"
                borderRadius="full"
                bg="white"
                opacity="0.5"
                animation={`${pulse} 5s ease-in-out infinite 2s`}
            />
        </Box>
    );
};

export default PublicVideoPage;

